module.exports = __webpack_public_path__ + "img/generateExam.98a3dafd.svg";